export default __webpack_public_path__ + "static/daylightfixed-318d2e915885f69cd08a4fc75cff5da0.png";